<template>
  <svg
    preserveAspectRatio="xMinYMin meet"
    viewBox="214 180 1373.5 254.39"
    role="img"
    :aria-labelledby="titleId"
  >
    <title :id="titleId">{{ localized.title }}</title>
    <g
      transform="translate(0.000000,751.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M8215 5017 c-125 -42 -200 -130 -224 -263 -27 -151 41 -300 167 -361 50 -24 69 -27 152 -28 84 0 102 3 152 28 65 32 121 89 152 156 31 67 31 235 0 302 -28 61 -93 125 -152 151 -60 25 -191 33 -247 15z m196 -120 c64 -34 99 -105 99 -202 0 -138 -75 -225 -193 -225 -73 0 -131 31 -164 87 -70 119 -38 288 64 342 54 29 137 28 194 -2z"
      ></path>
      <path
        d="M12539 5021 c-78 -26 -116 -61 -135 -127 -20 -69 -6 -124 44 -175 29 -28 59 -43 139 -69 56 -18 111 -41 123 -52 41 -38 15 -109 -46 -124 -44 -11 -140 3 -197 29 l-55 25 -11 -43 c-17 -68 -15 -72 47 -96 82 -33 239 -34 298 -2 91 49 131 136 104 226 -20 67 -66 102 -182 138 -139 43 -175 83 -129 140 18 22 27 24 98 23 56 -1 91 -7 126 -23 27 -11 50 -21 52 -21 9 0 26 103 19 109 -40 36 -232 63 -295 42z"
      ></path>
      <path
        d="M2140 5007 c0 -8 59 -194 130 -414 72 -221 130 -404 130 -407 0 -3 -58 -6 -130 -6 -92 0 -130 -3 -130 -12 0 -6 59 -192 130 -413 72 -221 130 -405 130 -408 0 -4 -59 -7 -131 -7 -120 0 -131 -1 -127 -17 3 -10 81 -199 174 -420 l168 -403 1067 0 1067 0 41 98 c22 53 101 241 175 417 l133 320 -134 3 c-133 3 -134 3 -127 25 13 44 255 787 260 802 5 13 -13 15 -130 15 -75 0 -136 1 -136 3 0 1 60 187 133 412 74 226 132 413 130 418 -2 4 -638 7 -1414 7 -1163 0 -1409 -2 -1409 -13z"
      ></path>
      <path
        d="M5805 5007 c-3 -7 -4 -152 -3 -322 l3 -310 57 -3 58 -3 2 230 3 231 149 -230 150 -230 68 0 68 0 0 325 0 325 -60 0 -60 0 -2 -229 -3 -230 -149 230 -148 229 -64 0 c-43 0 -66 -4 -69 -13z"
      ></path>
      <path
        d="M6688 5008 c-38 -100 -228 -627 -228 -632 0 -4 28 -6 63 -4 l62 3 26 75 26 75 128 0 128 0 26 -75 26 -75 63 -3 c46 -2 62 0 61 10 0 7 -51 153 -113 323 l-112 310 -76 3 c-55 2 -77 -1 -80 -10z m127 -243 c20 -60 39 -116 42 -122 3 -10 -17 -13 -86 -13 -71 0 -91 3 -91 14 0 27 83 247 90 239 4 -4 24 -57 45 -118z"
      ></path>
      <path
        d="M7060 4960 l0 -60 105 0 105 0 0 -265 0 -266 63 3 62 3 3 263 2 262 105 0 105 0 0 60 0 60 -275 0 -275 0 0 -60z"
      ></path>
      <path
        d="M7725 5007 c-3 -7 -4 -152 -3 -322 l3 -310 63 -3 62 -3 0 326 0 325 -60 0 c-40 0 -62 -4 -65 -13z"
      ></path>
      <path
        d="M8775 5008 c-3 -7 -4 -153 -3 -323 l3 -310 60 0 60 0 5 223 5 223 145 -225 145 -225 73 0 72 -1 -2 323 -3 322 -60 0 -60 0 -5 -223 -5 -224 -145 224 -145 223 -68 3 c-48 2 -69 -1 -72 -10z"
      ></path>
      <path
        d="M9666 5011 c-15 -24 -233 -631 -228 -636 3 -3 31 -5 63 -5 l57 0 27 80 27 80 126 0 127 0 28 -80 28 -80 60 0 c40 0 59 4 59 13 1 16 -211 609 -223 625 -11 14 -143 17 -151 3z m119 -238 c22 -64 41 -123 43 -130 3 -10 -18 -13 -87 -13 -50 0 -91 3 -91 7 0 14 85 253 90 253 3 0 23 -53 45 -117z"
      ></path>
      <path
        d="M10145 5007 c-3 -7 -4 -152 -3 -322 l3 -310 205 0 205 0 3 58 3 57 -146 0 -145 0 0 265 0 265 -60 0 c-40 0 -62 -4 -65 -13z"
      ></path>
      <path
        d="M10886 4883 c-3 -76 -9 -222 -12 -325 l-7 -188 62 0 61 0 1 178 c1 97 4 206 8 240 l6 64 78 -236 79 -237 66 3 65 3 83 245 82 245 4 -250 3 -250 59 0 59 0 -3 135 c-1 74 -5 218 -9 320 l-6 185 -85 3 -86 3 -73 -223 c-41 -123 -78 -234 -84 -248 -9 -22 -20 6 -91 220 l-81 245 -86 3 -86 3 -7 -138z"
      ></path>
      <path
        d="M11730 4792 c0 -261 7 -299 71 -363 85 -85 272 -93 375 -14 19 14 44 45 57 68 21 40 22 55 25 290 l3 247 -60 0 -59 0 -4 -227 c-4 -242 -9 -268 -54 -298 -59 -38 -159 -24 -198 28 -20 26 -21 45 -26 260 l-5 232 -62 3 -63 3 0 -229z"
      ></path>
      <path
        d="M12990 4695 l0 -325 218 2 217 3 3 53 3 52 -155 0 -156 0 0 80 0 80 125 0 125 0 0 55 0 55 -125 0 -125 0 0 80 0 80 156 0 155 0 -3 53 -3 52 -217 3 -218 2 0 -325z"
      ></path>
      <path
        d="M13564 5006 c-3 -8 -4 -117 -2 -243 3 -199 5 -232 22 -263 47 -90 116 -131 226 -138 97 -5 172 21 224 78 55 61 61 96 61 350 l0 225 -62 3 -63 3 0 -209 c0 -115 -3 -224 -6 -241 -16 -80 -107 -120 -193 -85 -73 29 -81 57 -81 317 l0 217 -60 0 c-44 0 -62 -4 -66 -14z"
      ></path>
      <path
        d="M14265 5008 c-3 -11 -25 -538 -25 -616 0 -20 5 -22 60 -22 l60 0 1 123 c1 67 4 175 8 240 l6 119 78 -237 79 -236 66 3 65 3 81 240 81 240 5 -245 5 -245 60 0 60 0 -4 155 c-2 85 -6 229 -10 320 l-6 165 -85 0 -85 0 -80 -242 c-44 -134 -82 -243 -85 -243 -3 0 -41 109 -85 243 l-80 242 -83 3 c-60 2 -83 -1 -87 -10z"
      ></path>
      <path
        d="M9005 4065 c-76 -31 -146 -103 -171 -177 -25 -72 -25 -195 0 -268 26 -74 102 -150 176 -176 77 -27 205 -24 283 5 31 12 57 23 57 24 -1 1 -6 25 -13 54 -7 28 -15 51 -19 52 -4 0 -29 -10 -55 -21 -56 -25 -163 -30 -203 -9 -122 64 -159 245 -73 359 51 68 163 92 258 56 75 -29 71 -29 89 22 9 26 16 51 16 55 0 5 -30 17 -66 29 -94 29 -201 27 -279 -5z"
      ></path>
      <path
        d="M14195 4066 c-76 -32 -146 -104 -171 -178 -25 -72 -25 -195 0 -268 26 -74 102 -150 176 -176 79 -27 206 -25 283 5 37 15 57 28 53 36 -2 7 -8 33 -11 59 -4 26 -10 45 -14 43 -70 -38 -112 -51 -171 -51 -76 0 -115 17 -158 70 -75 91 -62 265 23 332 61 48 181 55 261 14 l41 -21 17 56 c15 46 16 57 4 64 -30 20 -88 31 -178 35 -84 4 -102 2 -155 -20z"
      ></path>
      <path
        d="M6902 4053 c-19 -47 -222 -604 -222 -609 0 -2 28 -4 63 -4 l63 0 26 73 25 72 128 0 128 0 25 -72 26 -73 63 0 c35 0 63 3 62 8 0 4 -51 147 -112 317 l-112 310 -76 3 c-75 3 -76 2 -87 -25z m131 -226 l45 -127 -93 0 -92 0 46 130 c25 71 46 128 48 127 1 -2 22 -60 46 -130z"
      ></path>
      <path
        d="M7390 3760 l0 -320 60 0 60 0 0 125 0 125 125 0 125 0 0 55 0 55 -125 0 -125 0 0 85 0 85 156 0 155 0 -3 53 -3 52 -212 3 -213 2 0 -320z"
      ></path>
      <path
        d="M7937 4073 c-4 -3 -7 -147 -7 -320 l0 -313 65 0 64 0 3 113 3 112 45 3 45 2 68 -115 68 -115 74 0 75 0 -84 129 -84 129 28 12 c57 23 110 105 110 167 0 93 -53 160 -147 186 -60 17 -312 25 -326 10z m288 -119 c67 -32 70 -118 6 -161 -27 -18 -48 -23 -102 -23 l-69 0 0 100 0 100 66 0 c39 0 79 -6 99 -16z"
      ></path>
      <path
        d="M8550 3760 l0 -320 65 0 65 0 -2 318 -3 317 -62 3 -63 3 0 -321z"
      ></path>
      <path
        d="M9639 4053 c-31 -80 -219 -601 -219 -607 0 -3 28 -6 63 -6 l63 0 24 75 24 75 127 0 127 0 27 -75 28 -75 63 0 c35 0 64 1 64 3 0 1 -52 144 -114 317 l-114 315 -76 3 c-75 3 -76 2 -87 -25z m169 -349 c-3 -3 -44 -4 -91 -2 l-85 3 46 129 45 129 45 -127 c25 -70 42 -129 40 -132z"
      ></path>
      <path
        d="M10127 4073 c-4 -3 -7 -147 -7 -320 l0 -313 65 0 65 0 2 221 3 222 145 -224 146 -224 67 -3 67 -3 0 326 0 325 -60 0 -60 0 0 -227 0 -228 -134 205 c-74 113 -141 215 -151 228 -14 19 -25 22 -79 22 -34 0 -66 -3 -69 -7z"
      ></path>
      <path
        d="M11219 4053 c-31 -80 -219 -601 -219 -607 0 -3 28 -6 63 -6 l63 0 24 75 24 75 127 0 128 0 19 -52 c11 -29 23 -63 26 -75 7 -21 14 -23 72 -23 35 0 64 1 64 3 0 1 -52 144 -114 317 l-114 315 -76 3 c-75 3 -76 3 -87 -25z m169 -349 c-3 -3 -44 -4 -91 -2 l-85 3 46 129 45 129 45 -127 c25 -70 42 -129 40 -132z"
      ></path>
      <path
        d="M11706 3953 c-3 -71 -9 -215 -12 -320 l-7 -193 62 0 61 0 0 174 c0 95 3 202 7 237 l6 64 77 -230 77 -230 69 -3 69 -3 80 243 80 243 3 -247 2 -248 63 0 62 0 -10 317 -10 318 -87 3 -87 3 -76 -238 c-42 -131 -80 -241 -84 -246 -4 -4 -43 103 -86 238 l-79 245 -87 0 -86 0 -7 -127z"
      ></path>
      <path
        d="M12550 3760 l0 -320 220 0 220 0 0 55 0 55 -155 0 -155 0 0 75 0 75 125 0 125 0 0 55 0 55 -125 0 -125 0 0 80 0 80 155 0 155 0 0 55 0 55 -220 0 -220 0 0 -320z"
      ></path>
      <path
        d="M13130 3761 l0 -321 65 0 65 0 0 115 0 115 43 0 42 -1 69 -114 69 -115 73 0 74 0 -82 127 c-77 118 -81 127 -63 137 11 6 39 29 62 51 32 32 43 50 48 88 15 96 -18 165 -100 206 -46 23 -63 26 -207 29 l-158 4 0 -321z m279 198 c53 -19 78 -91 45 -137 -25 -36 -68 -52 -139 -52 l-65 0 0 100 0 100 64 0 c34 0 77 -5 95 -11z"
      ></path>
      <path
        d="M13740 3760 l0 -320 65 0 65 0 0 320 0 320 -65 0 -65 0 0 -320z"
      ></path>
      <path
        d="M14831 4058 c-33 -88 -221 -609 -221 -613 0 -3 28 -5 63 -5 l63 0 24 75 24 76 130 -3 129 -3 25 -72 24 -73 64 0 c35 0 64 1 64 3 0 1 -51 144 -114 317 l-113 315 -77 3 c-72 3 -77 1 -85 -20z m145 -271 c14 -43 24 -80 21 -83 -2 -3 -43 -4 -89 -2 l-85 3 45 128 45 129 19 -49 c10 -26 30 -83 44 -126z"
      ></path>
      <path
        d="M15320 3760 l0 -320 60 0 60 0 2 222 3 222 146 -224 146 -225 69 0 69 0 0 320 0 320 -62 3 -63 3 -2 -225 -3 -225 -145 224 -145 224 -67 1 -68 0 0 -320z"
      ></path>
      <path
        d="M6304 4042 c-49 -23 -79 -59 -101 -123 -15 -41 -22 -49 -56 -59 -45 -13 -44 -34 2 -38 30 -3 31 -5 26 -35 -3 -18 -17 -104 -31 -191 -14 -88 -30 -170 -35 -183 -9 -26 -49 -32 -49 -8 0 8 -11 22 -24 30 -47 31 -93 -22 -62 -70 22 -34 66 -40 119 -17 70 31 97 88 141 303 14 68 28 134 31 147 5 19 12 22 55 22 47 0 50 2 50 25 0 23 -4 25 -46 25 l-46 0 7 43 c11 63 21 84 44 90 17 4 24 -2 35 -27 8 -18 23 -35 34 -38 30 -8 62 18 62 51 0 60 -81 87 -156 53z"
      ></path>
      <path
        d="M5885 3875 c-107 -38 -169 -211 -109 -302 21 -33 73 -63 109 -63 138 1 236 182 169 312 -29 55 -100 78 -169 53z m93 -60 c16 -35 15 -69 -3 -140 -18 -68 -57 -125 -85 -125 -67 0 -65 163 3 263 25 36 69 37 85 2z"
      ></path>
      <path
        d="M6965 3154 c-124 -31 -178 -89 -178 -190 0 -100 55 -150 214 -198 98 -29 122 -49 117 -97 -9 -88 -125 -98 -299 -25 -13 6 -19 -3 -29 -38 -7 -25 -10 -52 -7 -60 9 -24 131 -58 210 -59 82 -1 137 14 186 51 62 46 88 143 57 216 -22 53 -79 91 -186 125 -104 34 -140 58 -140 96 0 72 122 92 246 40 20 -8 40 -15 44 -15 8 0 30 68 30 93 0 30 -201 77 -265 61z"
      ></path>
      <path
        d="M8204 3150 c-68 -14 -111 -37 -163 -85 -74 -69 -96 -127 -96 -250 0 -89 3 -106 28 -157 111 -225 459 -232 579 -11 39 72 54 165 39 244 -16 81 -41 130 -92 179 -67 64 -198 100 -295 80z m119 -111 c114 -31 173 -168 132 -305 -26 -88 -93 -138 -185 -138 -117 -1 -189 75 -198 207 -7 117 38 202 125 232 47 17 76 18 126 4z"
      ></path>
      <path
        d="M11130 3150 c-64 -14 -145 -56 -176 -93 -138 -163 -98 -444 75 -532 96 -48 214 -52 326 -12 39 14 40 15 38 61 -2 77 -5 79 -65 51 -39 -18 -70 -25 -116 -25 -77 0 -118 16 -159 63 -87 99 -62 294 45 355 54 30 153 31 223 1 27 -12 51 -20 53 -18 2 2 11 26 20 53 18 57 18 58 -57 81 -65 19 -153 26 -207 15z"
      ></path>
      <path
        d="M5800 2820 l0 -320 65 0 65 0 0 135 0 135 150 0 150 0 0 -135 0 -135 65 0 65 0 0 320 0 320 -65 0 -65 0 0 -130 0 -130 -150 0 -150 0 0 130 0 130 -65 0 -65 0 0 -320z"
      ></path>
      <path
        d="M6520 2820 l0 -320 65 0 65 0 0 320 0 320 -65 0 -65 0 0 -320z"
      ></path>
      <path
        d="M7310 3085 l0 -55 110 0 110 0 0 -265 0 -265 65 0 65 0 0 265 0 265 105 0 105 0 0 55 0 55 -280 0 -280 0 0 -55z"
      ></path>
      <path
        d="M8730 2820 l0 -320 65 0 65 0 0 115 0 115 45 0 44 0 68 -115 68 -114 73 -1 c85 0 87 -15 -18 147 -62 95 -68 109 -53 118 43 26 93 80 104 112 16 49 7 138 -18 171 -26 35 -77 69 -122 82 -20 5 -100 10 -178 10 l-143 0 0 -320z m316 177 c15 -17 24 -41 24 -60 0 -68 -57 -107 -155 -107 l-55 0 0 101 0 101 81 -4 c74 -3 83 -6 105 -31z"
      ></path>
      <path
        d="M9253 3133 c3 -5 52 -92 111 -194 l106 -186 0 -127 0 -126 65 0 65 0 0 124 0 125 98 173 c55 95 104 183 111 196 12 22 11 22 -57 22 l-69 0 -73 -136 -72 -136 -75 136 -75 136 -70 0 c-38 0 -67 -3 -65 -7z"
      ></path>
      <path
        d="M11542 2892 l3 -249 30 -49 c76 -122 297 -148 414 -48 71 61 81 107 81 369 l0 225 -65 0 -65 0 0 -225 c0 -249 -4 -271 -60 -300 -16 -8 -50 -15 -75 -15 -58 0 -100 21 -122 63 -15 27 -18 67 -21 255 l-4 222 -59 0 -60 0 3 -248z"
      ></path>
      <path
        d="M12230 2820 l0 -320 210 0 210 0 0 55 0 55 -145 0 -145 0 0 265 0 265 -65 0 -65 0 0 -320z"
      ></path>
      <path
        d="M12610 3085 l0 -55 110 0 110 0 0 -265 0 -265 65 0 65 0 0 265 0 265 105 0 105 0 0 55 0 55 -280 0 -280 0 0 -55z"
      ></path>
      <path
        d="M13280 2902 c0 -235 0 -239 25 -289 41 -82 115 -124 225 -126 132 -3 222 48 259 149 19 49 21 77 21 279 l0 225 -65 0 -65 0 0 -225 c0 -249 -4 -271 -60 -300 -16 -8 -50 -15 -75 -15 -58 0 -100 21 -122 63 -14 27 -18 68 -21 255 l-4 222 -59 0 -59 0 0 -238z"
      ></path>
      <path
        d="M13970 2820 l0 -320 65 0 65 0 0 116 0 115 46 -3 46 -3 68 -110 67 -110 71 -3 c40 -2 72 0 72 2 0 3 -33 56 -73 118 -40 62 -76 118 -80 125 -4 7 9 21 36 36 57 34 88 91 88 161 0 62 -10 87 -54 134 -47 49 -105 62 -274 62 l-143 0 0 -320z m314 181 c20 -19 26 -34 26 -65 0 -23 -7 -49 -14 -58 -21 -28 -80 -48 -141 -48 l-55 0 0 101 0 101 79 -3 c67 -4 83 -8 105 -28z"
      ></path>
      <path
        d="M14580 2820 l0 -320 220 0 220 0 0 55 0 55 -155 0 -155 0 0 80 0 80 131 0 130 0 -3 53 -3 52 -127 3 -128 3 0 74 0 75 155 0 155 0 0 55 0 55 -220 0 -220 0 0 -320z"
      ></path>
      <path
        d="M10224 3061 c-81 -37 -108 -116 -63 -190 11 -18 19 -34 17 -35 -2 -1 -20 -9 -41 -19 -97 -44 -104 -194 -10 -233 55 -24 119 -4 183 56 l34 32 46 -52 46 -53 47 18 c54 20 55 15 -26 101 l-38 41 54 31 c31 17 62 41 71 54 24 34 20 75 -9 94 -52 34 -110 -14 -78 -64 14 -22 12 -25 -24 -58 l-38 -34 -42 47 c-24 26 -43 50 -43 54 0 3 18 11 39 18 50 15 91 62 91 105 0 87 -114 133 -216 87z m110 -43 c20 -28 20 -51 1 -88 -23 -44 -53 -57 -77 -33 -27 28 -34 87 -14 118 21 33 68 34 90 3z m-88 -240 c16 -18 40 -45 53 -60 l23 -27 -41 -20 c-22 -12 -52 -21 -66 -21 -33 0 -65 33 -65 68 0 32 34 92 53 92 7 0 26 -15 43 -32z"
      ></path>
    </g>
  </svg>
</template>
<script>
import { useLocalization } from "@thegetty-private/getty-ui";
import { useId } from "vue";

export default {
  name: "NMAAHCLogo",
  props: {
    baseLocaleKey: {
      type: String,
      default: "g-jpca-footer"
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey,
        strings: {
          title: "nmaahc_image_logo"
        }
      })
    };
  },

  data() {
    return {
      /** id for title tag */
      titleId: `nmaahcLogo${useId()}`
    };
  }
};
</script>
